import { CloudDownload } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const VersionSourceHostIcon = (props: SvgIconProps) => (<CloudDownload {...props}/>);